var map = {
	"./0x.png": 1115,
	"./1inch.png": 1116,
	"./BAL-logo.png": 1117,
	"./BAT-logo.png": 1118,
	"./BUSD-logo.png": 1119,
	"./COMP-logo.png": 1120,
	"./CRV-icon.png": 1121,
	"./CRV-logo.jpg": 1122,
	"./CRV-logo.png": 1123,
	"./DAI-logo.png": 1124,
	"./ERPH0DMWsAEWBjy.jpg": 1125,
	"./ETH-icon.png": 1126,
	"./ETH-logo.png": 1127,
	"./FTM-logo.png": 1128,
	"./IEARN-icon.png": 1129,
	"./KNC-logo.png": 1130,
	"./LEND-logo.png": 1131,
	"./LINK-logo.png": 1132,
	"./MANA-logo.png": 1133,
	"./MKR-logo.png": 1134,
	"./MUSD-logo.png": 1135,
	"./OPYN-logo.png": 1136,
	"./REP-logo.png": 1137,
	"./SAI-logo.png": 1138,
	"./SNX-logo.png": 1139,
	"./SUSD-logo.png": 1140,
	"./TUSD-logo.png": 1141,
	"./UMA-logo.png": 1142,
	"./USDC-logo.png": 1143,
	"./USDT-logo.png": 1144,
	"./YFI-logo.png": 1145,
	"./ZRX-logo.png": 1146,
	"./aLINK-logo.png": 1147,
	"./aave.png": 1148,
	"./aave.svg": 1149,
	"./aavev2.svg": 1150,
	"./about-image-placeholder.png": 1151,
	"./adelphi.png": 1152,
	"./akropolis.svg": 1153,
	"./alchemix.png": 1154,
	"./alpha-homora.jpg": 1155,
	"./ampleforth.svg": 1156,
	"./ampleforthtokengeyser.png": 1157,
	"./amplf.png": 1158,
	"./anchor.svg": 1159,
	"./argent.png": 1160,
	"./armor-circle-logo.svg": 176,
	"./armor-logo.svg": 528,
	"./armor.png": 177,
	"./armor_background.jpg": 529,
	"./arnxm.png": 178,
	"./arrow-right.svg": 1161,
	"./badger.png": 1162,
	"./badgerdao.png": 1163,
	"./balancer.png": 1164,
	"./balancer.svg": 1165,
	"./bancor.png": 1166,
	"./barnbridge.png": 1167,
	"./benchmark-protocol.png": 1168,
	"./binance.png": 1169,
	"./binance.svg": 1170,
	"./blockFi.svg": 1171,
	"./bunnypancake.svg": 1172,
	"./bzx.png": 1173,
	"./cUSDC-logo.png": 1174,
	"./cUSDT-logo.png": 1175,
	"./celsius.svg": 1176,
	"./close-icon.svg": 1177,
	"./cofix.jpg": 1178,
	"./coinbase.png": 1179,
	"./coinbaseWalletIcon.svg": 1180,
	"./coinbase_mini.png": 1181,
	"./compound.png": 1182,
	"./compoundv2.png": 1183,
	"./connect_wallet.svg": 530,
	"./convex.png": 1184,
	"./corn-icon.svg": 1185,
	"./cover.jpg": 1186,
	"./cream.png": 1187,
	"./curve-3crv.png": 1188,
	"./curve.png": 1189,
	"./curvefi.jpg": 1190,
	"./dai.png": 1191,
	"./ddex.jpg": 1192,
	"./ddex.png": 1193,
	"./defipulse.png": 1194,
	"./defisnap.svg": 1195,
	"./defizap.png": 1196,
	"./deversifi.png": 1197,
	"./dforce-logo.jpg": 1198,
	"./dforce.svg": 1199,
	"./discord.svg": 1200,
	"./dodo.png": 1201,
	"./dodoexchange.png": 1202,
	"./dxdao.png": 1203,
	"./dydx.jpg": 1204,
	"./dydx.png": 1205,
	"./dydx.svg": 1206,
	"./eth.png": 1207,
	"./eth2.jpg": 1208,
	"./ethereum.png": 1209,
	"./etherscan.png": 1210,
	"./etherum.png": 1211,
	"./exclamation.svg": 1212,
	"./flexa.png": 1213,
	"./fonts/WorkSans-VariableFont_wght.ttf": 1214,
	"./fortmaticIcon.png": 1215,
	"./ftx.svg": 1216,
	"./gasprice.png": 1217,
	"./gemini.png": 1218,
	"./gift-box.svg": 1219,
	"./github.svg": 1220,
	"./gnosis-multisig.png": 1221,
	"./gnosis-safe.png": 1222,
	"./gnosis_safe.png": 1223,
	"./harvest.png": 1224,
	"./hegic.png": 1225,
	"./hero_armor_background.jpg": 409,
	"./hodlnaut.svg": 1226,
	"./iDAI-logo.png": 1227,
	"./icn-aethereum.svg": 1228,
	"./icn-ledger.svg": 1229,
	"./icn-metamask.svg": 1230,
	"./idex.png": 1231,
	"./idle.png": 1232,
	"./iearn.png": 1233,
	"./ill_coming_soon.svg": 1234,
	"./ill_coming_soon_no_shadow.svg": 410,
	"./inlock.png": 1235,
	"./keeperdao.jpg": 1236,
	"./kraken.png": 1237,
	"./kyber.png": 1238,
	"./kybernetwork.png": 1239,
	"./langs/en.svg": 531,
	"./langs/ja.svg": 532,
	"./langs/ko.svg": 533,
	"./langs/ru.svg": 534,
	"./langs/zh.svg": 535,
	"./ledger.png": 1240,
	"./ledn.svg": 1241,
	"./lendf.png": 1242,
	"./lendf.svg": 1243,
	"./liquity.png": 1244,
	"./logos/0x.svg": 536,
	"./logos/0x_v3.svg": 537,
	"./logos/1inch.svg": 538,
	"./logos/aave.svg": 539,
	"./logos/aave_v2.svg": 540,
	"./logos/adelphi.svg": 541,
	"./logos/akropolis.svg": 542,
	"./logos/alink.svg": 543,
	"./logos/alpha-homora.svg": 544,
	"./logos/ampleforth.svg": 545,
	"./logos/argent.svg": 546,
	"./logos/armor.svg": 547,
	"./logos/arnxm.svg": 548,
	"./logos/badger_dao.png": 1245,
	"./logos/balancer.svg": 549,
	"./logos/bancor.svg": 550,
	"./logos/bat.svg": 551,
	"./logos/binance.svg": 552,
	"./logos/block_fi.svg": 553,
	"./logos/busd.svg": 554,
	"./logos/bzx.svg": 555,
	"./logos/celsius.svg": 556,
	"./logos/check_circle.svg": 291,
	"./logos/cofix.png": 1246,
	"./logos/coinbase.svg": 557,
	"./logos/coinbase_wallet.svg": 558,
	"./logos/compound.svg": 559,
	"./logos/compound_v2.svg": 560,
	"./logos/connect_disconnected.svg": 292,
	"./logos/connect_wallet.svg": 561,
	"./logos/cover.jpg": 1247,
	"./logos/cream.svg": 562,
	"./logos/curve.svg": 563,
	"./logos/cusdc.svg": 564,
	"./logos/cusdt.svg": 565,
	"./logos/dai.svg": 566,
	"./logos/ddex.svg": 567,
	"./logos/defi_pulse.svg": 568,
	"./logos/defisnap.svg": 569,
	"./logos/defizap.svg": 570,
	"./logos/deversifi.svg": 571,
	"./logos/dforce.svg": 572,
	"./logos/dodo.svg": 573,
	"./logos/dxdao.svg": 574,
	"./logos/dydx.svg": 575,
	"./logos/eth.svg": 576,
	"./logos/etherscan.svg": 577,
	"./logos/flexa.png": 1248,
	"./logos/fortmatic.svg": 578,
	"./logos/ftm.svg": 579,
	"./logos/gas_price.svg": 293,
	"./logos/gemini.svg": 580,
	"./logos/gift.svg": 581,
	"./logos/gnosis_multisig.png": 1249,
	"./logos/gnosis_safe.png": 1250,
	"./logos/hegic.svg": 582,
	"./logos/hodlnaut.svg": 583,
	"./logos/icn_aethereum.svg": 584,
	"./logos/icn_ledger.svg": 585,
	"./logos/icn_metamask.svg": 586,
	"./logos/idai.png": 1251,
	"./logos/idex.svg": 587,
	"./logos/idle.svg": 588,
	"./logos/iearn.svg": 589,
	"./logos/inlock.svg": 590,
	"./logos/keeperdao.svg": 591,
	"./logos/knc.svg": 592,
	"./logos/kraken.svg": 593,
	"./logos/ledn.svg": 594,
	"./logos/lend.svg": 595,
	"./logos/lendf.png": 1252,
	"./logos/link.svg": 596,
	"./logos/lock.svg": 597,
	"./logos/maker_dao.svg": 598,
	"./logos/mana.svg": 599,
	"./logos/medium.svg": 600,
	"./logos/melon.svg": 601,
	"./logos/metamask.svg": 602,
	"./logos/metamask_right.svg": 603,
	"./logos/moloch.png": 1253,
	"./logos/mooniswap.svg": 604,
	"./logos/mstable.svg": 605,
	"./logos/musd.png": 1254,
	"./logos/nexo.svg": 606,
	"./logos/nexus_mutants.svg": 607,
	"./logos/nft.png": 1255,
	"./logos/notional.png": 1256,
	"./logos/nucypher.svg": 608,
	"./logos/nuo.png": 1257,
	"./logos/o_curve.svg": 609,
	"./logos/opyn.svg": 610,
	"./logos/paraswap.png": 1258,
	"./logos/perpetual.jpg": 1259,
	"./logos/pooltogether.svg": 611,
	"./logos/portis.svg": 612,
	"./logos/protect.svg": 613,
	"./logos/ren.svg": 614,
	"./logos/rep.svg": 615,
	"./logos/safe.svg": 616,
	"./logos/sai.svg": 617,
	"./logos/saturn_dao.png": 1260,
	"./logos/set_protocol.svg": 618,
	"./logos/snx.svg": 619,
	"./logos/squarelink.png": 1261,
	"./logos/stats.svg": 620,
	"./logos/susd.png": 1262,
	"./logos/sushiswap.svg": 621,
	"./logos/synthetix.svg": 622,
	"./logos/tbtc.svg": 623,
	"./logos/telegram.svg": 624,
	"./logos/tornado.svg": 625,
	"./logos/torus.svg": 626,
	"./logos/totle.svg": 627,
	"./logos/trezor.svg": 628,
	"./logos/truefi.jpg": 1263,
	"./logos/truffle.svg": 629,
	"./logos/trust_wallet.svg": 630,
	"./logos/tusd.svg": 631,
	"./logos/twitter.svg": 632,
	"./logos/uma.svg": 633,
	"./logos/uniswap.svg": 634,
	"./logos/usdc.svg": 635,
	"./logos/usdt.svg": 636,
	"./logos/wallet_connect.svg": 637,
	"./logos/wbtc.svg": 638,
	"./logos/yam.png": 1264,
	"./logos/yearn_finance.svg": 639,
	"./maker_dao.png": 1265,
	"./makerdao.png": 1266,
	"./makerdaomcd.png": 1267,
	"./medium.svg": 1268,
	"./melon.png": 1269,
	"./metamask-right.png": 180,
	"./metamask.png": 1270,
	"./metamask.svg": 1271,
	"./moloch.png": 1272,
	"./mooniswap.png": 1273,
	"./mooniswap.svg": 1274,
	"./mstable.png": 1275,
	"./mstable.svg": 1276,
	"./new_armor_background.jpg": 294,
	"./nexo.svg": 1277,
	"./nexus-mutants.png": 1278,
	"./nft.png": 1279,
	"./notional.png": 1280,
	"./nu_cypher.png": 1281,
	"./nucypher.svg": 1282,
	"./nuo.png": 1283,
	"./oCurve-logo.svg": 1284,
	"./oneinch.svg": 1285,
	"./opyn.png": 1286,
	"./originusd.png": 1287,
	"./oxv3.png": 1288,
	"./pancakeswap.svg": 1289,
	"./paraswap.png": 1290,
	"./perpetual.jpg": 1291,
	"./pool_together.png": 1292,
	"./pooltogether.png": 1293,
	"./portisIcon.png": 1294,
	"./reflexer.png": 1295,
	"./ren.svg": 1296,
	"./renvm.png": 1297,
	"./safe.png": 1298,
	"./saturn_dao.png": 1299,
	"./saturndao.png": 1300,
	"./set_protocol.png": 1301,
	"./squarelink.png": 1302,
	"./stakedao.png": 1303,
	"./sushiswap.jpg": 1304,
	"./synthetix.png": 1305,
	"./synthetix.svg": 1306,
	"./tbtc.svg": 1307,
	"./telegram.svg": 1308,
	"./thorchain.svg": 1309,
	"./tokensets.png": 1310,
	"./tornado.png": 1311,
	"./tornadocash.png": 1312,
	"./torus.jpg": 1313,
	"./totle.png": 1314,
	"./trezor.png": 1315,
	"./truefi.jpg": 1316,
	"./truffle.png": 1317,
	"./trustWallet.png": 1318,
	"./twitter.svg": 1319,
	"./uma.png": 1320,
	"./uniswap-logo.png": 1321,
	"./uniswap.png": 1322,
	"./uniswap.svg": 1323,
	"./uniswapv2.png": 1324,
	"./uniswapv3.svg": 1325,
	"./venus.svg": 1326,
	"./vesper.jpeg": 1327,
	"./wBTC-icon.png": 1328,
	"./wBTC-logo.png": 1329,
	"./walletConnectIcon.svg": 1330,
	"./wbtc.svg": 1331,
	"./yam.png": 1332,
	"./yam_finance.png": 1333,
	"./ycUSDC-logo.png": 1334,
	"./ycUSDT-logo.png": 1335,
	"./yearn.svg": 1336,
	"./yearnfinance.png": 1337,
	"./yield.jpg": 1338
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56;